import { ObjectValues, STORY_STATUSES } from 'types';

export const LIMITED_EDITING_STATUSES: Array<ObjectValues<typeof STORY_STATUSES>> = [
  STORY_STATUSES.PUBLISHED,
  STORY_STATUSES.EXPIRED,
  STORY_STATUSES.UNPUBLISHED,
];
